import * as Yup from 'yup';
import { getRequiredText } from '../../../../global/helpers/transformer';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { MaxCharacter255 } from '../../constants/constant-strings';
import { MidYearProps } from '../../models/arc-epi-props';

const defaultTerminationDateError = 'Termination Date cannot be in the past.';
const negativeVolumeError = 'Volume cannot be less than $0';
export function midYearValidationSchema(labelSetting: LabelSettingProps, midYearProps: MidYearProps, hasGroup: boolean, hasPlans: boolean, hasUnemployment: boolean, hasExtenuatingCircunstances: boolean) {

	const shape = hasGroup && hasPlans ? {

		date_of_qualifying_event: Yup.date().nullable().required(getRequiredText(labelSetting.requiredFormat, midYearProps.dateOfQualifyingLabel)),
		memo: Yup.string().nullable().max(255, midYearProps.maxCharacterErrorText || MaxCharacter255),
		specialRequests: Yup.string().nullable().max(255, midYearProps.maxCharacterErrorText || MaxCharacter255),
		extenuatingCircumstances: hasExtenuatingCircunstances ? Yup.string().nullable().max(255, midYearProps.maxCharacterErrorText || MaxCharacter255) : null,

		medicalPlanBillingAccount: Yup.string().when('medicalPlan',
			(medicalPlan, yup) => medicalPlan ? yup.required(getRequiredText(labelSetting.requiredFormat, midYearProps.billingAccountLabel)) : yup),

		dentalPlanBillingAccount: Yup.string().when('dentalPlan',
			(dentalPlan, yup) => dentalPlan ? yup.required(getRequiredText(labelSetting.requiredFormat, midYearProps.billingAccountLabel)) : yup),

		groupLifePlanBillingAccount: Yup.string().when('groupLifePlan',
			(groupLifePlan, yup) => groupLifePlan ? yup.required(getRequiredText(labelSetting.requiredFormat, midYearProps.billingAccountLabel)) : yup),

		//supplementalLifePlanBillingAccount: Yup.string().required(getRequiredText(labelSetting.requiredFormat, midYearProps.billingAccountLabel)),
		//: Yup.string().required(getRequiredText(labelSetting.requiredFormat, midYearProps.planLabel)),

		//supplementalSpousePlanBillingAccount: Yup.string().required(getRequiredText(labelSetting.requiredFormat, midYearProps.billingAccountLabel)),
		//supplementalSpousePlan: Yup.string().required(getRequiredText(labelSetting.requiredFormat, midYearProps.planLabel)),

		longTermDisabilityPlanBillingAccount: Yup.string().when('longTermDisabilityPlan',
			(longTermDisabilityPlan, yup) => longTermDisabilityPlan ? yup.required(getRequiredText(labelSetting.requiredFormat, midYearProps.billingAccountLabel)) : yup),

		shortTermDisabilityPlanBillingAccount: Yup.string().when('shortTermDisabilityPlan',
			(shortTermDisabilityPlan, yup) => shortTermDisabilityPlan ? yup.required(getRequiredText(labelSetting.requiredFormat, midYearProps.billingAccountLabel)) : yup),

		unemploymentInsurancePlanBillingAccount: hasUnemployment ? Yup.string().when('unemploymentInsurancePlan',
			(unemploymentInsurancePlan, yup) => unemploymentInsurancePlan ? yup.required(getRequiredText(labelSetting.requiredFormat, midYearProps.billingAccountLabel)) : yup) : null,

		medicalPlanTerminateDate: Yup.date().nullable()
			.when('medicalPlanEffectiveDate',
				(medicalPlanEffectiveDate, yup) => medicalPlanEffectiveDate ? yup.min(medicalPlanEffectiveDate, midYearProps.terminationDateErrorMessage || defaultTerminationDateError) : yup),

		dentalPlanTerminateDate: Yup.date().nullable()
			.when('dentalPlanEffectiveDate',
				(dentalPlanEffectiveDate, yup) => dentalPlanEffectiveDate ? yup.min(dentalPlanEffectiveDate, midYearProps.terminationDateErrorMessage || defaultTerminationDateError) : yup),
		groupLifePlanTerminateDate: Yup.date().nullable()
			.when('groupLifePlanEffectiveDate',
				(groupLifePlanEffectiveDate, yup) => groupLifePlanEffectiveDate ? yup.min(groupLifePlanEffectiveDate, midYearProps.terminationDateErrorMessage || defaultTerminationDateError) : yup),
		supplementalLifePlanTerminateDate: Yup.date().nullable()
			.when('supplementalLifePlanEffectiveDate',
				(supplementalLifePlanEffectiveDate, yup) => supplementalLifePlanEffectiveDate ? yup.min(supplementalLifePlanEffectiveDate, midYearProps.terminationDateErrorMessage || defaultTerminationDateError) : yup),
		supplementalSpousePlanTerminateDate: Yup.date().nullable()
			.when('supplementalSpousePlanEffectiveDate',
				(supplementalSpousePlanEffectiveDate, yup) => supplementalSpousePlanEffectiveDate ? yup.min(supplementalSpousePlanEffectiveDate, midYearProps.terminationDateErrorMessage || defaultTerminationDateError) : yup),
		longTermDisabilityPlanTerminateDate: Yup.date().nullable()
			.when('longTermDisabilityPlanEffectiveDate',
				(longTermDisabilityPlanEffectiveDate, yup) => longTermDisabilityPlanEffectiveDate ? yup.min(longTermDisabilityPlanEffectiveDate, midYearProps.terminationDateErrorMessage || defaultTerminationDateError) : yup),
		shortTermDisabilityPlanTerminateDate: Yup.date().nullable()
			.when('shortTermDisabilityPlanEffectiveDate',
				(shortTermDisabilityPlanEffectiveDate, yup) => shortTermDisabilityPlanEffectiveDate ? yup.min(shortTermDisabilityPlanEffectiveDate, midYearProps.terminationDateErrorMessage || defaultTerminationDateError) : yup),
		unemploymentInsurancePlanTerminateDate: Yup.date().nullable()
			.when('unemploymentInsurancePlanEffectiveDate',
				(unemploymentInsurancePlanEffectiveDate, yup) => unemploymentInsurancePlanEffectiveDate ? yup.min(unemploymentInsurancePlanEffectiveDate, midYearProps.terminationDateErrorMessage || defaultTerminationDateError) : yup),
		groupLifePlanVolume: Yup.number().min(0, midYearProps.negativeNumberError),
		supplementalLifePlanVolume: Yup.number().min(0, midYearProps.negativeNumberError || negativeVolumeError),
		supplementalSpousePlanVolume: Yup.number().min(0, midYearProps.negativeNumberError || negativeVolumeError),
	} : {};

	return Yup.object().shape(shape);
}

